import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class AccountService {
    private userSubject: BehaviorSubject<any>;
    public user: Observable<any>;

    constructor(
        private router: Router,
        private http: HttpClient
    ) {
        this.userSubject = new BehaviorSubject<any>((localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null));
        this.user = this.userSubject.asObservable();

    }

    public get userValue(): any {
        return this.userSubject.value;
    }

    login(username, password, role) {
        if (role == 'user') {
            return this.http.post<any>(`${environment.apiUrl}site`, { username, password })
                .pipe(map(user => {
                    if (user && typeof user.data != 'undefined') {
                        // store user details and jwt token in local storage to keep user logged in between page refreshes
                        localStorage.setItem('user', JSON.stringify(user.data));
                        this.userSubject.next(user.data);
                    }
                    return user;
                }));
        }        else if (role == 'tasker') {
            return this.http.post<any>(`${environment.apiUrl}site/taskerlogin`, { username, password })
                .pipe(map(user => {
                    if(user && typeof user.data !='undefined'){
                        // store user details and jwt token in local storage to keep user logged in between page refreshes
                        localStorage.setItem('user', JSON.stringify(user.data));
                        this.userSubject.next(user.data);
                    }
                    return user;
                }));
        }
        else if (role == 'taskers') {
            return this.http.post<any>(`${environment.apiUrl}site/taskerlogin1`, { username, password })
                .pipe(map(user => {
                    if(user && typeof user.data !='undefined'){
                        // store user details and jwt token in local storage to keep user logged in between page refreshes
                        localStorage.setItem('user', JSON.stringify(user.data));
                        this.userSubject.next(user.data);
                    }
                    return user;
                }));
        } 
        else {
            return this.http.post<any>(`${environment.apiUrl}/users/authenticate`, { username, password })
                .pipe(map(user => {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('user', JSON.stringify(user));
                    this.userSubject.next(user);
                    return user;
                }));
        }
    }

    socialLogin(useraData) {
        return this.http.post<any>(`${environment.apiUrl}site-social-login`, useraData)
            .pipe(map(user => {
                if (user && typeof user.data != 'undefined') {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('user', JSON.stringify(user.data));
                    this.userSubject.next(user.data);
                }
                return user;
            }));
    }

    faceBookLogin(useraData) {
        return this.http.post<any>(`${environment.apiUrl}site-facebook-login`, useraData)
            .pipe(map(user => {
                if (user && typeof user.data != 'undefined') {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('user', JSON.stringify(user.data));
                    this.userSubject.next(user.data);
                }
                return user;
            }));
    }

    checkSocialLoginUser(useraData) {
        return this.http.post<any>(`${environment.apiUrl}check-social-login-user`, useraData)
            .pipe(map(user => {
                return user;
            }));
    }

    logout() {
        // remove user from local storage and set current user to null
        localStorage.clear();
        this.userSubject.next(null);
        this.router.navigate(['/']);
    }

    register(user: any) {
        return this.http.post(`${environment.apiUrl}/users/register`, user);
    }

    getAll() {
        return this.http.get<any[]>(`${environment.apiUrl}/users`);
    }

    getById(id: string) {
        return this.http.get<any>(`${environment.apiUrl}/users/${id}`);
    }

    update(id, params) {
        return this.http.put(`${environment.apiUrl}/users/${id}`, params)
            .pipe(map(x => {
                // update stored user if the logged in user updated their own record
                if (id == this.userValue.id) {
                    // update local storage
                    const user = { ...this.userValue, ...params };
                    localStorage.setItem('user', JSON.stringify(user));

                    // publish updated user to subscribers
                    this.userSubject.next(user);
                }
                return x;
            }));
    }

    delete(id: string) {
        return this.http.delete(`${environment.apiUrl}/users/${id}`)
            .pipe(map(x => {
                // auto logout if the logged in user deleted their own record
                if (id == this.userValue.id) {
                    this.logout();
                }
                return x;
            }));
    }
}